// ECMAScript's Unicode property escapes are unavailable at this app's current compilation target.
// Keep the explicit Unicode White_Space set aligned with .NET's string.IsNullOrWhiteSpace.
const whitespaceOnlyPattern = /^[\u0009-\u000d\u0020\u0085\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000]*$/;

/**
 * Converts the editor model to the Dynamic Forms wire invariant. HTML parsing and sanitizing remain
 * backend responsibilities; the editor only knows whether its own decoded text model is blank.
 */
export function normalizeRichTextEditorValue(plainText: string, html: string): string {
  return whitespaceOnlyPattern.test(plainText) ? '' : html.trim();
}
